import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['box'];

  // end: the box's right edge meets the trigger, so a score near the sidebar stays on screen.
  // start: the box's left edge meets the trigger, so a pill on the left of a row opens underneath it.
  static values = { align: { type: String, default: 'end' } };

  show(event) {
    const box = this.boxTarget;
    box.classList.remove('hidden');

    if (getComputedStyle(box).position === 'fixed') {
      const rect = event.currentTarget.getBoundingClientRect();
      const width = box.offsetWidth;
      const margin = 8;
      const preferred = this.alignValue === 'start' ? rect.left : rect.right - width;
      const maxLeft = Math.max(margin, window.innerWidth - width - margin);
      box.style.top = `${rect.bottom + 4}px`;
      box.style.left = `${Math.min(Math.max(preferred, margin), maxLeft)}px`;
    }
  }

  hide() {
    this.boxTarget.classList.add('hidden');
  }

  toggle() {
    this.boxTarget.classList.toggle('hidden');
  }
}
